import React, { useState } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	useMediaQuery,
	Slide,
	Grid,
	useTheme,
	makeStyles,
	IconButton,
	FormControl,
	TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useForm } from "react-hook-form";
import CloseIcon from "@material-ui/icons/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function AssignLabToOperator(props) {
	const theme = useTheme();
	const classes = useStyles();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const { labList, operatorLabs, onSubmit } = props;
	const [laboratories, setLaboratories] = useState(operatorLabs);
	const { handleSubmit } = useForm();

	const updateOperator = () => {
		props.close();
		onSubmit(laboratories.map((lab) => lab._id));
	};

	return (
		<Dialog
			PaperProps={{ style: { borderRadius: 45 } }}
			maxWidth="sm"
			fullScreen={fullScreen}
			open={props.open}
			TransitionComponent={Transition}
		>
			<IconButton aria-label="close" className={classes.closeButton} onClick={props.close}>
				<CloseIcon />
			</IconButton>
			<DialogTitle className={classes.dialogTitle}>Asignar Laboratorios</DialogTitle>
			<DialogContent>
				<form className={classes.form} onSubmit={handleSubmit(updateOperator)}>
					<Grid container spacing={2}>
						<Grid item lg={12} xs={12} sm={12}>
							<FormControl variant="outlined" className={`${classes.formControl}  ${classes.shrinkLabel}`}>
								<Autocomplete
									multiple
									id="laboratorios"
									options={labList}
									getOptionLabel={(option) => option.name}
									filterSelectedOptions
									variant="outlined"
									label="laboratorios"
									value={laboratories}
									onChange={(event, newValue) => {
										setLaboratories(newValue);
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											id="laboratorios"
											name="laboratorios"
											variant="outlined"
											label="laboratorios"
											placeholder="laboratorios"
										/>
									)}
								/>
							</FormControl>
						</Grid>
					</Grid>
					<DialogActions>
						<Button
							type="submit"
							fullWidth
							size="small"
							variant="contained"
							color="secondary"
							className={classes.submit}
							style={{ textTransform: "capitalize", borderRadius: "20px" }}
						>
							Guardar
						</Button>
					</DialogActions>
				</form>
			</DialogContent>
		</Dialog>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
		minWidth: 300,
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(2),
		top: theme.spacing(2),
		color: "#FFF",
		backgroundColor: theme.palette.secondary.main,
		width: 30,
		height: 30,
		"&:hover": {
			backgroundColor: theme.palette.secondary.main,
		},
	},
	dialogTitle: {
		textAlign: "left",
		color: theme.palette.primary.main,
		"& h2": {
			fontWeight: "bold",
		},
	},
	formControl: {
		width: "100%",
		minWidth: 120,
		"& div": {
			borderRadius: 25,
		},
	},
	select: {
		"& > div:nth-child(1)": {
			padding: "10.5px 14px",
		},
	},
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
	shrinkLabel: {
		"& > label:nth-child(1)": {
			transform: "translate(14px, -6px) scale(0.75)",
		},
		"& > div:nth-child(2)": {
			"& > fieldset": {
				"& > legend": {
					maxWidth: 1000,
				},
			},
		},
	},
}));
